export default {
  publicExam_pass_score: 'Pass',
  publicExam_number_participants: 'Number of participant/participants',
  publicExam_total_score: "Full score: {totalScoreStr}",
  publicExam_min_score: 'Qualified: {minScoreStr}',
  publicExam_totalTestNum: 'Number of participants: {totalTestNum}',
  publicExam_current_tab: 'No {currentTab} yet'
}

